import { Button, Stack, Typography, useTheme } from '@mui/material';
import { getFormattedDateString, RHFRichTextEditor } from '@zeta-core';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { normalizeSlateData } from './helper';
import { IMessageDetail } from '@zeta-types';

interface MessageDetailsProps {
  message: IMessageDetail & {
    from: string;
    to: string;
  };
  entityConfig: {
    fromName: string;
    toName: string;
    fromUserID: string;
    toUserID: string;
  };
}

export const MessageDetails = ({ message, entityConfig }: MessageDetailsProps) => {
  const theme = useTheme();
  const [isExpanded, setIsExpanded] = useState(false);

  const methods = useForm({
    defaultValues: {
      viewMessage: (() => {
        try {
          const parsedContent = JSON.parse(message.content || '[]');
          return normalizeSlateData(parsedContent);
        } catch (error) {
          return normalizeSlateData(message.content || '');
        }
      })(),
    },
  });

  const usersArray = [
    {
      name: entityConfig.toName,
      userID: entityConfig.toUserID,
    },
    {
      name: entityConfig.fromName,
      userID: entityConfig.fromUserID,
    },
  ];

  const getFromName = usersArray.find((user) => user.userID === message.fromUserID)?.name || '';
  const getToName = usersArray.find((user) => user.userID === message.toUserID)?.name || '';

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          color: theme.palette.text.secondary,
          fontSize: '0.875rem',
        }}
      >
        <Typography variant="body2">
          Date and time: {getFormattedDateString(message?.createdAt, 'DD/MM/YYYY HH:mm')} | From: {getFromName} | To: {getToName}
        </Typography>
        <Button variant="text" color="primary" size="small" onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? 'Show less' : 'Read message'}
        </Button>
      </Stack>

      {isExpanded && message.content && (
        <FormProvider {...methods}>
          <RHFRichTextEditor name="viewMessage" disabled={true} />
        </FormProvider>
      )}

      {isExpanded && message.reference && (
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: '0.875rem',
          }}
        >
          Date and Time: {getFormattedDateString(message?.createdAt, 'DD/MM/YYYY HH:mm')} | Reference Number: {message.reference}
        </Typography>
      )}
    </Stack>
  );
};
